module.exports = __webpack_public_path__ + "coffin.jpg?143017858be6e13fd7f282cd198c14d8";